import OneTimeContracts from './OneTimeContracts';

export default OneTimeContracts;
